import { useState, useContext, useMemo } from 'react';
import { StaticContext } from '@sm/webassets';

import { PACKAGE_IDS } from '~pricing/lib/constants';
import assignCTABasedOnPackageTier from '~pricing/pages/shared/';
import { createPackagesList } from '~pricing/lib/lib-helpers';
import { PackageDataSet, PackageSet } from '~pricing/lib/summaryPackages';

/**
 * Move this logic into the context provider Hack is working one
 * @param packageData
 * @param packageSet
 * @returns
 */
export default function usePackagesWithCTALabel(
  packageData: PackageDataSet,
  packageSet: PackageSet
): { packages: PackageDataSet } {
  const [packages, setPackages] = useState<PackageDataSet>([]);
  const { user } = useContext(StaticContext);
  const { isAuthenticated, package: currentPackage } = user;

  useMemo(() => {
    /**
     * TODO: Richmond Frimpong
     * This will be eventually moved to the context provider,
     * that spits out the current package the user has
     */
    const currentlyPurchased = packageData
      .filter(displayed => parseInt(displayed.id, 10) !== PACKAGE_IDS.ENT_PLATINUM)
      .find(pkg => pkg.id === currentPackage);
    const packagesToDisplayBasedOnRoute: PackageDataSet = createPackagesList(packageData, packageSet);
    const assignedPackages = assignCTABasedOnPackageTier(
      packagesToDisplayBasedOnRoute,
      currentlyPurchased,
      isAuthenticated
    );
    setPackages(assignedPackages.slice());
  }, [packageData, packageSet, currentPackage, isAuthenticated]);

  return {
    packages,
  };
}
